import React, { Component } from 'react';
import Sdk from 'api.digitalpages.module.sdk.api';
import { BadgesService } from '../../services/badges';
import { CoinsService } from '../../services/coins';
import { UsersService } from '../../services/user';
import InputMask from 'react-input-mask';
import { Utils } from '../../utils/utils';
import './login.css';

import {
  ContentHeader,
  CoinsBox,
  BadgesBox,
  BackBtn,
  Footer,
  Preloader
} from '../../components';

export default class ViewLogin extends Component {
  constructor(props) {
    super(props);

    this.loginRef = React.createRef();
    this.emailRef = React.createRef();
    this.cpfRef = React.createRef();
    this.passwordRef = React.createRef();

    this.state = {
      "render_coins_box": false,
      "render_badges_box": false,
      "render_preloader": false,
      "render_login_error": false,
      "render_password_error": false,
      // "current_sign_in_mode": null,
      "current_sign_in_mode": "login",
      "projects": null,
      "selected_project": null,
      // "auth_step": "initial",
      "auth_step": "login",
      "field_login": "",
      "field_email": "",
      "field_cpf": "",
      "signin_in": false
    }
  }

  componentDidMount() {
  }

  componentWillMount() {
    var user = UsersService.getUser();
    if (user !== null) {
      window.location = window.location.origin + window.location.pathname + "#/";
    }
  }

  async signIn() {
    var _this = this;
    _this.setState({
      "signin_in": true
    })

    Utils.mobileHapticFeeback();

    var projectUid = this.state.selected_project;
    var currentSignInMode = this.state.current_sign_in_mode;
    var login;
    if (currentSignInMode === "login") login = this.state.field_login;
    if (currentSignInMode === "email") login = this.state.field_email;
    if (currentSignInMode === "cpf") login = this.state.field_cpf;
    var password = this.passwordRef.current.value;


    // usuario.cogna@euconquisto.com
    try {
      // Fazer login no projeto específico
      // var userData = await Sdk.Api.authorization.signinByProject(projectUid, login, password);
      const userData = await Sdk.Api.authorization.signinByLogin(login, password);

      UsersService.setUser(JSON.stringify(userData));
      await this.setActiveProject(projectUid);

      var user = UsersService.getUser();
      if (user !== null) {
        window.location = window.location.origin + window.location.pathname + "#/";
      }
    } catch (e) {
      _this.setState({
        "render_password_error": true
      });

      Utils.mobileVibrate();
    }

    _this.setState({
      "signin_in": false
    })
  }

  async setActiveProject(projectUid) {
    window.localStorage.setItem("active-project", projectUid);
    // var userDetails = await UsersService.getUserDetails();
    var userDetails = await Sdk.Api.dynamic.bridge(`/auth/v1.0/user/me`, null, 'GET');
    var projects = userDetails.projects;

    var activeProject = projects.find(project => project.uid === projectUid);
    await this.setCustomization(activeProject);
  }

  async setCustomization(activeProject) {
    var customizationConnector = activeProject.connectors.find(connector => connector.type === "Customization_1");

    if (customizationConnector !== undefined) {
      var connector = await UsersService.getConnector(customizationConnector.uid);
      window.localStorage.setItem("customization", JSON.stringify(connector.configuration.configs));
    }
  }

  // find login
  // https://api.digitalpages.com.br/auth/v1.0/directory/user/login/projects/available?ignore_user_context=true&login=43021250807


  // sign in
  // https://api.digitalpages.com.br/auth/v1.0/signin/project/uid/fd9fda02-1840-ed11-a27c-dc98407f4bc7

  changeAuthStep(mode) {
    this.setState({
      "auth_step": mode
    });

    Utils.mobileHapticFeeback();
  }

  getContinueLabel() {
    const { auth_step } = this.state;
    if (auth_step === "login") return ""
  }

  async goToProjects() {
    this.setState({
      "render_preloader": true,

    });

    Utils.mobileHapticFeeback();

    var currentSignInMode = this.state.current_sign_in_mode;
    var login;
    if (currentSignInMode === "login") login = this.state.field_login;
    if (currentSignInMode === "email") login = this.state.field_email;
    if (currentSignInMode === "cpf") login = this.state.field_cpf;

    // var projects = await UsersService.getUserProjects(login);
    var projects = await Sdk.Api.dynamic.bridge(`/auth/v1.0/directory/user/login/projects/available?ignore_user_context=true&login=${login}`, null, 'GET');
    if (projects.error) projects = [];

    this.setState({
      "render_preloader": false
    });

    if (projects.length === 0) {
      this.setState({
        "render_login_error": true
      });
    } else if (projects.length === 1) {
      this.setState({
        "auth_step": "password",
        "selected_project": projects[0].uid,
        "projects": projects
      });
    } else {
      this.setState({
        "auth_step": "password",
        "selected_project": projects.filter(project => project.name !== "*B2C")[0].uid,
        "projects": projects
      });
    }
  }

  changeStepToLogin() {
    this.changeAuthStep("login");
    this.setState({ "current_sign_in_mode": "login" });
  }

  changeStepToEmail() {
    this.changeAuthStep("email");
    this.setState({ "current_sign_in_mode": "email" });
  }

  changeStepToCpf() {
    this.changeAuthStep("cpf");
    this.setState({ "current_sign_in_mode": "cpf" });
  }

  onChangeLogin(val) {
    this.setState({
      "field_login": val.toLowerCase()
    });
  }

  onChangeEmail(val) {
    this.setState({
      "field_email": val.toLowerCase()
    });
  }

  onChangeCpf(val) {
    this.setState({
      "field_cpf": val.replaceAll(".", "").replaceAll("-", "")
    });
  }

  redirectTo(path) {
    window.location = window.location.origin + window.location.pathname + "#" + path;
  }

  render() {
    var _this = this;
    const {
      render_preloader,
      render_login_error,
      render_password_error,
      current_sign_in_mode,
      auth_step,
      projects,
      selected_project
    } = this.state;

    return <div className="rdp-react-template-view-login" role="main">
      <div className="rdp-react-template-view-login-header">
        <span className="rdp-react-template-view-login-header-logo"></span>
      </div>
      {render_preloader &&
        <Preloader/>
        // <div className="rdp-react-template-view-login-preloader">
        //   <div className="rdp-react-template-view-login-preloader-loader"></div>
        // </div>
      }

      {render_login_error &&
        <div className="rdp-react-template-view-login-error">
          <div className="rdp-react-template-view-login-error-box">
            <span className="rdp-react-template-view-login-error-box-icon"></span>
            {current_sign_in_mode === "login" && <h1 className="rdp-react-template-view-login-error-box-title">Login inválido!</h1>}
            {current_sign_in_mode === "email" && <h1 className="rdp-react-template-view-login-error-box-title">E-mail inválido!</h1>}
            {current_sign_in_mode === "cpf" && <h1 className="rdp-react-template-view-login-error-box-title">CPF inválido!</h1>}
            <p className="rdp-react-template-view-login-error-box-message">
              Verifique se as informações estão corretas e <br></br>tente novamente.
            </p>
            <button className="rdp-component-btn primary position-left icon-left" onClick={() => this.setState({ "render_login_error": false })}>Voltar</button>
          </div>
        </div>
      }

      {render_password_error &&
        <div className="rdp-react-template-view-login-error">
          <div className="rdp-react-template-view-login-error-box">
            <span className="rdp-react-template-view-login-error-box-icon"></span>
            <h1 className="rdp-react-template-view-login-error-box-title">Senha inválida!</h1>
            <p className="rdp-react-template-view-login-error-box-message">
              Verifique se a senha está correta e <br></br>tente novamente.
            </p>
            <button className="rdp-component-btn primary position-left icon-left" onClick={() => this.setState({ "render_password_error": false })}>Voltar</button>
          </div>
        </div>
      }

      <div className="rdp-react-template-view-login-content">
        <span className="rdp-react-template-view-login-title">
          {auth_step === "initial" && "Que bom te ver por aqui!"}
          {auth_step === "login" && "Digite seu login"}
          {auth_step === "email" && "Digite seu e-mail"}
          {auth_step === "cpf" && "Digite seu CPF"}
          {auth_step === "select-project" && "Selecione a organização"}
          {auth_step === "password" && "Digite a senha"}
        </span>
        {auth_step === "initial" &&
          <>
            <button className="rdp-component-btn primary position-left icon-login" onClick={() => this.changeStepToLogin("login")}>Entrar com Login</button>
            <button className="rdp-component-btn primary position-left icon-email" onClick={() => this.changeStepToEmail("email")}>Entrar com E-mail</button>
            <button className="rdp-component-btn primary position-left icon-cpf" onClick={() => this.changeStepToCpf("cpf")}>Entrar com CPF</button>
          </>
        }

        {auth_step === "login" &&
          <input
            ref={this.loginRef}
            className="rdp-react-template-view-login-input"
            type="text"
            placeholder="Login"
            value={this.state.field_login}
            onChange={(e) => this.onChangeLogin(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                this.goToProjects();
              }
            }}
          ></input>
        }

        {auth_step === "email" &&
          <input
            ref={this.emailRef}
            className="rdp-react-template-view-login-input"
            type="text"
            placeholder="E-mail"
            value={this.state.field_email}
            onChange={(e) => this.onChangeEmail(e.target.value)}
          ></input>
        }

        {auth_step === "cpf" &&
          <InputMask
            id="cpf-ref"
            className="rdp-react-template-view-login-input"
            mask="999.999.999-99"
            type="text"
            placeholder="CPF"
            ref={this.cpfRef}
            value={this.state.field_cpf}
            onChange={(e) => this.onChangeCpf(e.target.value)}
          />
        }

        {(auth_step === "login" || auth_step === "email" || auth_step === "cpf") &&
          <>
            <div class="rdp-component-btn-group-flex">
              {/* <button className="rdp-component-btn secondary position-left icon-left" onClick={() => this.changeAuthStep("initial")}>Voltar</button> */}
              <button className="rdp-component-btn primary position-right icon-right" onClick={() => this.goToProjects()}>Continuar</button>
            </div>
            <div class="rdp-component-links-group">
              <button className="rdp-component-link" onClick={() => this.redirectTo("/user/forgot")}>Esqueci minha senha</button>
              <button className="rdp-component-link" onClick={() => this.redirectTo("/cadastro")}>Criar conta</button>
            </div>
          </>
        }

        {auth_step === "select-project" &&
          <div className="rdp-react-template-view-login-projects">
            {projects === null &&
              <div>Carregando...</div>
            }
            {projects &&
              <>
                <ul className="rdp-react-template-view-login-projects-items">
                  {projects.length > 0 && projects.map(function (project, index) {
                    return <li className={`rdp-react-template-view-login-project-item ${selected_project === project.uid ? "active" : ""}`} key={index} onClick={() => _this.setState({ "selected_project": project.uid })}>
                      {/* <span className="rdp-react-template-view-login-project-item-logo"></span> */}
                      <span className={`rdp-react-template-view-login-project-item-name`}>{project.name}</span>
                    </li>
                  })}
                </ul>
                <div class="rdp-component-btn-group-flex">
                  <button className="rdp-component-btn secondary position-left icon-left" onClick={() => this.changeAuthStep(this.state.current_sign_in_mode)}>Voltar</button>
                  <button className={`rdp-component-btn primary position-right icon-right ${selected_project === null ? "inactive" : ""}`} onClick={() => this.changeAuthStep("password")}>Continuar</button>
                </div>
              </>
            }
          </div>
        }

        {auth_step === "password" &&
          <>
            <input ref={this.passwordRef} className="rdp-react-template-view-login-input" type="password" placeholder="Senha"
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  this.signIn();
                }
              }}></input>
            <div class="rdp-component-btn-group-flex">
              <button className="rdp-component-btn secondary position-left icon-left" onClick={() => this.changeAuthStep("login")}>Voltar</button>
              <button className="rdp-component-btn primary position-right icon-right" onClick={() => this.signIn()}>{this.state.signin_in ? "Aguarde..." : "Continuar"}</button>
            </div>
            <div class="rdp-component-links-group">
              <button className="rdp-component-link" onClick={() => this.redirectTo("/user/forgot")}>Esqueci minha senha</button>
              <button className="rdp-component-link" onClick={() => this.redirectTo("/cadastro")}>Criar conta</button>
            </div>
          </>
        }
      </div>

      {/* <div className="rdp-react-template-view-login-footer">
        <div className="rdp-react-template-view-login-footer-items">
          <div className="rdp-react-template-view-login-footer-items-content">
            <a className="rdp-react-template-view-login-footer-item">Sobre</a>
            <a className="rdp-react-template-view-login-footer-item">Termos de uso</a>
            <a className="rdp-react-template-view-login-footer-item">Política de privacidade</a>
            <a className="rdp-react-template-view-login-footer-item">Fale conosco</a>
            <a className="rdp-react-template-view-login-footer-item">Dúvidas frequentes</a>
          </div>
        </div>
        <div className="rdp-react-template-view-login-footer-copyright">
          <div className="rdp-react-template-view-login-footer-copyright-content">
            <div className="rdp-react-template-view-login-footer-copyright-right">Copyright © 2025. Todos os direitos reservados.</div>
            <div className="rdp-react-template-view-login-footer-copyright-left">
              <span className="rdp-react-template-view-login-footer-copyright-left-item">
                Serviço Nacional de Aprendizagem Comercial – SP
              </span>
              <span className="rdp-react-template-view-login-footer-copyright-left-item">
                CNPJ: 03.709.814/0001-98
              </span>
            </div>
          </div>
        </div>
      </div> */}
      <Footer style={{ width: '100%' }} />
    </div>;
  }
}
